import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Description, InputGroup, Label, TextField } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';
import {
    branchScopeLayout,
    isBranchScopeFullWidth,
    type BranchScopeCopy,
    type BranchScopeLayout,
} from './branchScopeMeta';

type BranchScopeLineProps = {
    /** `null` until the branch list gives it. */
    branchName: string | null;
    copy: BranchScopeCopy;
    layout: BranchScopeLayout;
};

/**
 * A BranchAdmin's own branch, read-only, where an OrgAdmin gets the picker
 * (bos-app#118, bos-app#119). Their figures are that branch's whatever they
 * ask for, so there is nothing to pick; the line says whose stock they are
 * reading. The group's prefix and suffix give the icons their muted tone.
 */
export const BranchScopeLine: React.FC<BranchScopeLineProps> = ({
    branchName,
    copy,
    layout,
}) => {
    const { t } = useTranslation('pages');
    const placement = branchScopeLayout({ layout });

    return (
        <TextField
            className={placement.field()}
            fullWidth={isBranchScopeFullWidth(layout)}
            isReadOnly
            value={
                branchName ??
                t('products.components.productTable.filters.ownBranch')
            }
            {...getNodeTestIdProp('product-filters-branch-readonly')}
        >
            <Label>{copy.label}</Label>
            <InputGroup className={placement.control()} variant="secondary">
                <InputGroup.Prefix>
                    <Icon aria-hidden icon="solar:shop-2-linear" />
                </InputGroup.Prefix>
                <InputGroup.Input />
                <InputGroup.Suffix>
                    <Icon aria-hidden icon="gravity-ui:lock" />
                </InputGroup.Suffix>
            </InputGroup>
            {copy.lineDescription ? (
                <Description>{copy.lineDescription}</Description>
            ) : null}
        </TextField>
    );
};
